<nav #navbar class="navbar active"
  [ngStyle]="{'width': sidebarSize === '' ? 'calc(100% - var(--sidebar-width)) ' : 'calc(100% - '+ sidebarSize+')'}">
  <div class="d-flex h-div justify-content-between gap-3 w-100 ps-2 pe-2 ps-sm-3 pe-sm-3">

    <div mat-button class="f-sc-btn me-2 d-flex align-items-center gap-2 ">
      <!-- <app-feather-icons [icon]="'menu'" [class]="'header-icon mt-0'"></app-feather-icons> -->
      <img (click)="mobileMenuSidebarOpen($event,'overlay-open')" src="assets/images/icons/new-menu-ic.png" alt="">
      <div class="heading-1 mt-0">{{pageTitle}}</div>

      <div class="d-flex gap-2 gap-sm-3 top-part align-items-center">
        <div>
          <div [matMenuTriggerFor]="notificationMenu" (menuOpened)="onMenuOpened()"
            class="nav-notification-icons m-0 cursor-pointer">
            <img src="assets/images/icons/notification.svg" alt="">
          </div>
          <mat-menu #notificationMenu="matMenu" class="nfc-menu" (closed)="onMenuClosed()">
            <ng-container *ngIf="menuOpened">
              <div class="nfc-header">
                <h5 class="mb-0">Notitications</h5>
              </div>
              <div class="nfc-dropdown">
                <ng-scrollbar style="height: 350px" visibility="hover">
                  <div class="noti-list header-menu">
                    <div class="menu">
                      <div class="d-flex" *ngFor="let notification of notificationArr" [@fadeOut]>
                        <button mat-menu-item onClick="return false;">
                          <div class="d-flex align-items-center user-profile">
                            <div class="profile-img me-2" [appBackgroundImg]="notification.profile_picture"></div>
                            <span class="menu-info">
                              <span class="menu-title hide-lines-2">{{notification.message}}</span>
                              <span class="menu-desc mt-2">
                                <i class="material-icons">access_time</i>
                                {{notification.create_time}}
                              </span>
                            </span>
                          </div>
                        </button>
                        <div class="d-flex align-items-center p-3 cursor-pointer">
                          <img (click)="hideNotification($event, notification.id)"
                            src="assets/images/icons/delete-icon.svg" alt="">
                        </div>
                      </div>
                      <div class="mat-table__message" *ngIf="notificationArr.length == 0">
                        <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="" />
                      </div>
                    </div>
                  </div>
                </ng-scrollbar>
              </div>
              <div class="nfc-footer">
                <a class="nfc-read-all" routerLink="/notifications">Read
                  All Notifications</a>
              </div>
            </ng-container>
          </mat-menu>
        </div>
        <!-- #END# Notifications-->
        <div class="nav-item user_profile">

          <div [matMenuTriggerFor]="profilemenu" class="cursor-pointer">
            <div class="chip dropdown-toggle " ngbDropdownToggle class="">
              <span>{{userInfo.company_name}}</span>
              <img *ngIf="!userInfo.company_logo" src="assets/images/logo/login.png" class="user_img" width="32"
                height="32" alt="User">
              <img *ngIf="userInfo.company_logo" [src]="imageURL+userInfo.company_logo" class="user_img" width="32"
                height="32" alt="User">
            </div>
          </div>

          <mat-menu #profilemenu="matMenu" class="profile-menu">
            <div class="noti-list">
              <div class="menu ">
                <div class="user_dw_menu">
                  <button mat-menu-item routerLink="/account">
                    <app-feather-icons [icon]="'user'" [class]="'user-menu-icons'"></app-feather-icons>Account
                  </button>
                  <button mat-menu-item routerLink="/settings">
                    <app-feather-icons [icon]="'settings'" [class]="'user-menu-icons'"></app-feather-icons>Settings
                  </button>

                  <button mat-menu-item (click)="logout()" class="log-out">
                    <app-feather-icons [icon]="'log-out'" [class]="'user-menu-icons'"></app-feather-icons> Logout
                  </button>
                </div>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end" [ngClass]="isNavbarCollapsed ? '' : 'show'" *ngIf="!isViewCompany">
      <div class="d-flex  r-side align-items-center justify-content-end gap-2 gap-sm-3">
        <!-- Full Screen Button -->
        <div class="upgrad-btn gap-1" routerLink="/package/offer-package" *ngIf="isUpgradeBtn">
          <span class="mb-1"> <img src="assets/images/icons/upgrade_plan.svg" class="img-fluid up-i" alt=""></span>
          Upgrade Plan
        </div>

        <div class="fullscreen cursor-pointer">
          <div class="f-sc-btn" (click)="callFullscreen()">
            <!-- <app-feather-icons [icon]="'maximize'" [class]="'header-icon'"></app-feather-icons> -->
            <img src="assets/images/icons/full_screen.png" alt="">
          </div>
        </div>
        <!-- #END# Full Screen Button -->
        <!-- <li class="nav-item">
          <mat-menu #languagemenu="matMenu" class="lang-item-menu">
            <div *ngFor="let item of listLang" class="lang-item">
              <button mat-menu-item class="dropdown-item lang-item-list"
                (click)="setLanguage(item.text, item.lang, item.flag)"
                [ngClass]="{'active': langStoreValue === item.lang}">
                <img src="{{item.flag}}" class="flag-img" height="12"> <span class="align-middle">{{item.text}}</span>
              </button>
            </div>
          </mat-menu>
        </li> -->
        <!-- #START# Notifications-->
        <div class="d-flex gap-2 gap-sm-3 bottom-part align-items-center">
          <div>
            <div [matMenuTriggerFor]="notificationMenu" (menuOpened)="onMenuOpened()"
              class="nav-notification-icons m-0 cursor-pointer">
              <img src="assets/images/icons/notification.svg" alt="">
            </div>
            <mat-menu #notificationMenu="matMenu" class="nfc-menu" (closed)="onMenuClosed()">
              <ng-container *ngIf="menuOpened">
                <div class="nfc-header">
                  <h5 class="mb-0">Notitications</h5>
                </div>
                <div class="nfc-dropdown">
                  <ng-scrollbar style="height: 350px" visibility="hover">
                    <div class="noti-list header-menu">
                      <div class="menu">
                        <div class="d-flex" *ngFor="let notification of notificationArr" [@fadeOut]>
                          <button mat-menu-item onClick="return false;">
                            <div class="d-flex align-items-center user-profile">
                              <div class="profile-img me-2" [appBackgroundImg]="notification.profile_picture"></div>
                              <span class="menu-info">
                                <span class="menu-title hide-lines-2">{{notification.message}}</span>
                                <span class="menu-desc mt-2">
                                  <i class="material-icons">access_time</i>
                                  {{notification.create_time}}
                                </span>
                              </span>
                            </div>
                          </button>
                          <div class="d-flex align-items-center p-3 cursor-pointer">
                            <img (click)="hideNotification($event, notification.id)"
                              src="assets/images/icons/delete-icon.svg" alt="">
                          </div>
                        </div>


                        <div class="mat-table__message" *ngIf="notificationArr.length == 0">
                          <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="" />
                        </div>

                      </div>
                    </div>
                  </ng-scrollbar>
                </div>
                <div class="nfc-footer">
                  <a class="nfc-read-all" routerLink="/notifications">Read
                    All Notifications</a>
                </div>
              </ng-container>
            </mat-menu>
          </div>
          <!-- #END# Notifications-->
          <div class="nav-item user_profile">

            <div [matMenuTriggerFor]="profilemenu" class="cursor-pointer">
              <div class="chip dropdown-toggle " ngbDropdownToggle class="">
                <span>{{userInfo.company_name}}</span>
                <img *ngIf="!userInfo.company_logo" src="assets/images/logo/login.png" class="user_img" width="32"
                  height="32" alt="User">
                <img *ngIf="userInfo.company_logo" [src]="imageURL+userInfo.company_logo" class="user_img" width="32"
                  height="32" alt="User">
              </div>
            </div>

            <mat-menu #profilemenu="matMenu" class="profile-menu">
              <div class="noti-list">
                <div class="menu ">
                  <div class="user_dw_menu">
                    <button mat-menu-item routerLink="/account">
                      <app-feather-icons [icon]="'user'" [class]="'user-menu-icons'"></app-feather-icons>Account
                    </button>
                    <button mat-menu-item routerLink="/settings">
                      <app-feather-icons [icon]="'settings'" [class]="'user-menu-icons'"></app-feather-icons>Settings
                    </button>

                    <button mat-menu-item (click)="logout()" class="log-out">
                      <app-feather-icons [icon]="'log-out'" [class]="'user-menu-icons'"></app-feather-icons> Logout
                    </button>
                  </div>
                </div>
              </div>
            </mat-menu>
          </div>
        </div>
        <!-- #END# Tasks -->
      </div>
    </div>
  </div>
</nav>